const STORAGE_KEY = 'ultra_prime_crash_bet_panel_map'

const readMap = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return {}
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch {
    return {}
  }
}

const writeMap = (map) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(map))
  } catch {
    // ignore quota / private mode
  }
}

export const rememberCrashBetPanel = (betId, panelIndex) => {
  if (betId == null || (panelIndex !== 0 && panelIndex !== 1)) return
  const map = readMap()
  map[String(betId)] = panelIndex
  writeMap(map)
}

export const forgetCrashBetPanel = (betId) => {
  if (betId == null) return
  const map = readMap()
  delete map[String(betId)]
  writeMap(map)
}

export const clearCrashBetPanelMap = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    // ignore
  }
}

let unfinishedRestoreEpoch = 0

export const invalidateCrashUnfinishedRestore = () => {
  unfinishedRestoreEpoch += 1
}

export const getCrashUnfinishedRestoreEpoch = () => unfinishedRestoreEpoch

export const clearCrashBetPanelState = () => {
  clearCrashBetPanelMap()
  invalidateCrashUnfinishedRestore()
}

export const assignUnfinishedBetsToPanels = (bets = [], existingPanels = [null, null]) => {
  const list = Array.isArray(bets) ? bets.filter(Boolean).slice(0, 2) : []
  const map = readMap()
  const panels = [
    existingPanels[0] || null,
    existingPanels[1] || null
  ]
  const usedIds = new Set(
    panels.filter(Boolean).map((bet) => String(bet.id ?? bet))
  )

  for (const bet of list) {
    if (usedIds.has(String(bet.id))) continue
    const remembered = map[String(bet.id)]
    if ((remembered === 0 || remembered === 1) && panels[remembered] == null) {
      panels[remembered] = bet
      usedIds.add(String(bet.id))
    }
  }

  for (const bet of list) {
    if (usedIds.has(String(bet.id))) continue
    const emptyIndex = panels[0] == null ? 0 : panels[1] == null ? 1 : -1
    if (emptyIndex < 0) break
    panels[emptyIndex] = bet
    usedIds.add(String(bet.id))
    rememberCrashBetPanel(bet.id, emptyIndex)
  }

  return panels
}
